import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DISPATCH_ID, CURRENCY } from "../libs/utils/Const";
import { ApiClient } from "../libs/apiClient";
import $ from 'jquery';
import { processPendingPayment, supportsInvoiceReprocessing } from '../libs/utils/processPendingPayment';

// Reutiliza el cliente HTTP autenticado de la aplicación para solicitar el detalle de sesión.
const apiClient = ApiClient.getInstance();

// Muestra únicamente las facturas que hicieron problemática la sesión seleccionada.
class PendingCutDetailModal extends Component {
    state = { invoices: [], selectedInvoiceKeys: [], processingInvoices: false };

    // Consulta primero para abrir el modal Bootstrap con datos siempre que sea posible.
    componentDidMount = async () => {
        await this.getDetail();
        $('#pendingCutDetailModal').modal('show');
    };

    // El backend vuelve a validar el idSession seleccionado antes de ejecutar SQL.
    getDetail = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, idSession } = this.props;
        enableSpinner(true);
        try {
            const response = await apiClient.getPendingCutProblemDetails({ idSession });
            if (response.status !== 1) {
                showAlert({ type: "error", message: response.message || 'No se pudo obtener el detalle del corte.' });
                return;
            }
            // Una lista vacía es válida si los datos cambiaron después de la consulta principal.
            this.setState({ invoices: response?.data?.invoices || [] });
        } catch (error) {
            showAlert({ type: "error", message: "No se pudo obtener el detalle del corte. Intenta de nuevo." });
        } finally {
            enableSpinner(false);
        }
    };

    // HANA puede devolver decimales como cadenas; por eso se convierten explícitamente.
    formatAmount = (value, currency = CURRENCY) => {
        const number = Number(value) || 0;
        return `${currency || CURRENCY} ${number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    // Traduce la clasificación monetaria del procedimiento a etiquetas operativas.
    getReason = (invoice) => {
        const reasons = {
            PAYMENT_NOT_PROCESSED: { className: 'badge-warning', label: 'Pago no procesado' },
            ROUNDING_DIFFERENCE: { className: 'badge-danger', label: 'Diferencia de redondeo' },
            FISE_DIFFERENCE: { className: 'badge-info', label: 'FISE no aplicado' },
            PARTIAL_PAYMENT: { className: 'badge-secondary', label: 'Pago parcial' },
            OVERPAYMENT: { className: 'badge-dark', label: 'Pago excedente' },
        };
        const reason = reasons[invoice.reason] || { className: 'badge-danger', label: 'Diferencia de pago' };
        return <span className={`badge ${reason.className}`}>{reason.label}</span>;
    };

    // SQL devuelve un nombre representativo; no etiqueta varios métodos como si fueran uno.
    getPaymentMethod = (invoice) => {
        if (Number(invoice.paymentMethods) > 1) return 'Varios métodos';
        return invoice.pm_Name || '-';
    };

    // Oculta mediante Bootstrap y luego avisa al padre para desmontar el componente.
    handleClose = () => {
        $('#pendingCutDetailModal').modal('hide');
        this.props.onClose && this.props.onClose();
    };

    getInvoiceKey = (invoice) => `${this.props.idSession}-${invoice.idSale}-${invoice.DocEntry}`;

    toggleInvoice = (invoice) => {
        const key = this.getInvoiceKey(invoice);
        this.setState((state) => ({
            selectedInvoiceKeys: state.selectedInvoiceKeys.includes(key)
                ? state.selectedInvoiceKeys.filter((selectedKey) => selectedKey !== key)
                : [...state.selectedInvoiceKeys, key],
        }));
    };

    reprocessSelectedInvoices = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, idSession } = this.props;
        const { invoices, selectedInvoiceKeys, processingInvoices } = this.state;
        if (!supportsInvoiceReprocessing || !selectedInvoiceKeys.length || processingInvoices) return;

        const selectedInvoices = invoices
            .filter((invoice) => selectedInvoiceKeys.includes(this.getInvoiceKey(invoice)))
            .map((invoice) => ({
                idSession: Number(idSession),
                idSale: Number(invoice.idSale),
                DocEntry: Number(invoice.DocEntry),
            }));

        this.setState({ processingInvoices: true });
        enableSpinner(true);
        try {
            const results = [];
            for (const invoice of selectedInvoices) {
                try {
                    const result = await processPendingPayment('INVOICE', invoice);
                    results.push({ DocEntry: invoice.DocEntry, ...result });
                } catch (error) {
                    results.push({ DocEntry: invoice.DocEntry, processed: false, message: error.message });
                }
            }
            const successful = results.filter((result) => result.processed);
            const failed = results.filter((result) => !result.processed);
            this.setState((state) => ({
                selectedInvoiceKeys: state.selectedInvoiceKeys.filter((key) =>
                    !selectedInvoices.some((invoice) => successful.some((result) => result.DocEntry === invoice.DocEntry)
                        && key === this.getInvoiceKey(invoice))),
            }));
            await this.getDetail();
            showAlert({
                type: failed.length ? "error" : "success",
                message: `${successful.length} factura(s) con pago reportado como procesado; ${failed.length} sin confirmación.` +
                    (failed[0] ? ` DocEntry ${failed[0].DocEntry}: ${failed[0].message}` : ''),
            });
        } catch (error) {
            showAlert({ type: "error", message: "No fue posible solicitar el reprocesamiento de las facturas." });
        } finally {
            this.setState({ processingInvoices: false });
            enableSpinner(false);
        }
    };

    render() {
        const { invoices, selectedInvoiceKeys, processingInvoices } = this.state;
        const { sessionInfo } = this.props;
        // Replica el cálculo de origen usado por el renderizador del listado.
        const origin = sessionInfo?.typeUser === 'MVENTAS' ? 'Gas' : 'Comercio';

        return (
            <div className="modal fade" id="pendingCutDetailModal" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: 0 }}>
                            <h5 className="modal-title">
                                Facturas problemáticas del corte
                                <span className="text-muted ml-2">
                                    (Sesión {sessionInfo?.idSession || ''} - {sessionInfo?.userName || sessionInfo?.idUser || ''} - {origin})
                                </span>
                            </h5>
                            <button type="button" className="close text-white" onClick={this.handleClose} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-sm">
                                    <thead className="table-header">
                                        <tr>
                                            <th className="text-center">Documento</th>
                                            <th className="text-left">Cliente</th>
                                            <th className="text-center">Estado</th>
                                            <th className="text-right">Total</th>
                                            <th className="text-right">Aplicado</th>
                                            <th className="text-right">Diferencia</th>
                                            <th className="text-left">Método</th>
                                            <th className="text-right">Monto registrado</th>
                                            <th className="text-center">Motivo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* La clave compuesta distingue ventas que podrían compartir una referencia SAP. */}
                                        {invoices.length ? invoices.map((invoice) => {
                                            const selected = selectedInvoiceKeys.includes(this.getInvoiceKey(invoice));
                                            return (
                                                <tr
                                                    key={`${invoice.DocEntry}-${invoice.idSale}`}
                                                    onClick={() => this.toggleInvoice(invoice)}
                                                    style={{ backgroundColor: selected ? '#FFF8D2' : '', cursor: 'pointer' }}
                                                >
                                                    <td className="text-center">{invoice.DocNum}</td>
                                                    <td className="text-left">{invoice.CardCode} - {invoice.CardName}</td>
                                                    <td className="text-center">{invoice.DocStatus}</td>
                                                    <td className="text-right">{this.formatAmount(invoice.DocTotal, invoice.DocCur)}</td>
                                                    <td className="text-right">{this.formatAmount(invoice.SumApplied, invoice.DocCur)}</td>
                                                    <td className="text-right">{this.formatAmount(invoice.difference, invoice.DocCur)}</td>
                                                    <td className="text-left">{this.getPaymentMethod(invoice)}</td>
                                                    <td className="text-right">{this.formatAmount(invoice.amount)}</td>
                                                    <td className="text-center">{this.getReason(invoice)}</td>
                                                </tr>
                                            );
                                        }) : (
                                            <tr><td colSpan="9" className="text-center">No se encontraron facturas problemáticas.</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            {!supportsInvoiceReprocessing && <small className="text-muted mr-2">El reproceso individual requiere soporte de DocEntry en el backend.</small>}
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={this.reprocessSelectedInvoices}
                                disabled={!supportsInvoiceReprocessing || !selectedInvoiceKeys.length || processingInvoices}
                            >
                                <i className="fa fa-refresh mr-1"></i> Reprocesar
                            </button>
                            <button type="button" className="btn botonCerrar" onClick={this.handleClose}>Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Usa el spinner y las alertas existentes de Redux en lugar de duplicar estado local de UI.
const mapStateToProps = store => ({ notificationReducer: store.NotificationReducer });

const mapDispatchToProps = dispatch => ({
    enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
});

export default connect(mapStateToProps, mapDispatchToProps)(PendingCutDetailModal);
